const GetSelectedStatusColor = ({ status }) => {
  const commonTextStyle = {
    color: "white",
    fontWeight: "400",
    fontSize: "14px",
  };

  const commonImageStyle = {
    height: "10px",
    width: "10px",
  };

  const statusData = {
    available: { label: "Available", icon: "/assets/SelectedAvailable.svg" },
    faulted: { label: "Faulted", icon: "/assets/SelectedFaulted.svg" },
    notcompatible: {
      label: "Not Compatible",
      icon: "/assets/SelectedNotCompatible.svg",
    },
    disconnected: {
      label: "Disconnected",
      icon: "/assets/SelectedDisconnected.svg",
    },
    unavailable: {
      label: "Unavailable",
      icon: "/assets/SelectedDisconnected.svg",
    },
    charging: { label: "Charging", icon: "/assets/SelectedCharging.svg" },
    gunconnected: {
      label: "Gun connected",
      icon: "/assets/SelectedGunConnected.svg",
    },
    finished: { label: "Finished", icon: "/assets/SelectedFinished.svg" },
  };

  const normalizedStatus = status?.toLowerCase().replace(/\s+/g, "");

  const statusInfo = statusData[normalizedStatus];

  if (!statusInfo) return null;

  return (
    <div>
      <span style={commonTextStyle}>{statusInfo.label}</span>
      <span style={{ marginLeft: "4px" }}>
        <img
          src={statusInfo.icon}
          alt={statusInfo.label}
          style={commonImageStyle}
        />
      </span>
    </div>
  );
};

export default GetSelectedStatusColor;
